import React from 'react';
interface LogoProps {
  className?: string;
  dotClassName?: string;
}
export function Logo({
  className = 'text-2xl',
  dotClassName = 'w-2 h-2'
}: LogoProps) {
  return <div className={`font-display tracking-tight flex items-baseline ${className}`} data-id="element-350">
      Aijentik
      <span className={`bg-brand-orange rounded-full inline-block ml-[2px] ${dotClassName}`} data-id="element-351"></span>
    </div>;
}